"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _input = _interopRequireDefault(require("./input"));

var _utils = require("./utils");

var _parts = require("./parts");

var _withTheme = require("../../wrappers/with-theme");

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _matchSorter = require("match-sorter");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Dropdown = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      searchable = _ref.searchable,
      opened = _ref.opened,
      direction = _ref.direction,
      customTheme = _ref.customTheme;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n      absolute left-0 z-40 overflow-hidden w-full\n      ".concat(opened ? "block" : "hidden", "\n    "),
    style: direction === "down" ? {
      top: "100%"
    } : {
      bottom: "100%"
    },
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.accent3, " my-1 ").concat(searchable ? "pt-1" : "")
  }, children));
});

var DropdownItem = function DropdownItem(_ref2) {
  var children = _ref2.children,
      isActive = _ref2.isActive,
      customTheme = _ref2.customTheme,
      props = _objectWithoutProperties(_ref2, ["children", "isActive", "customTheme"]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: "\n        px-2 whitespace-no-wrap\n        ".concat(theme.itemText, "\n        ").concat(isActive ? "cursor-not-allowed ".concat(theme.accent2) : "cursor-pointer hover:".concat(theme.accent2), "\n      ")
  }), children);
};

var Identity = function Identity(i) {
  return i;
};

var Select = /*#__PURE__*/function (_React$Component) {
  _inherits(Select, _React$Component);

  var _super = _createSuper(Select);

  function Select() {
    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "checkOutside", function (e) {
      if (_this.node.contains(e.target)) {
        return;
      }

      _this.closeDropdown();
    });

    _defineProperty(_assertThisInitialized(_this), "openDropdown", function (e) {
      e.stopPropagation();

      _this.setState({
        opened: true,
        hasFocus: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeDropdown", function (e) {
      _this.state.opened && _this.vcNode && _this.vcNode.focus();

      _this.setState({
        opened: false,
        direction: "down",
        search: ""
      });
    });

    _this.node = null;
    _this.vcNode = null;
    _this.dropdown = null;
    _this.state = {
      opened: false,
      direction: "down",
      hasFocus: false,
      search: ""
    };
    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.autoFocus && this.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.vcNode && this.vcNode.focus();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      document.addEventListener("mousedown", this.checkOutside);

      if (this.dropdown && this.state.opened && this.state.direction === "down") {
        var rect = this.dropdown.getBoundingClientRect();

        if (rect.top + rect.height > window.innerHeight) {
          this.setState({
            direction: "up"
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener("mousedown", this.checkOutside);
    }
  }, {
    key: "getValues",
    value: function getValues() {
      var _this2 = this;

      var values = [];
      if (!(0, _utils.hasValue)(this.props.value)) return [];

      if (!Array.isArray(this.props.value)) {
        values = [this.props.value];
      } else {
        values = this.props.value;
      }

      return this.getOptions().filter(function (option) {
        // return values.includes(this.props.valueAccessor(option));
        return values.reduce(function (a, c) {
          return a || (0, _deepEqual["default"])(_this2.props.valueAccessor(option), c);
        }, false);
      });
    }
  }, {
    key: "addItem",
    value: function addItem(e, v) {
      e.stopPropagation();
      this.closeDropdown();
      v = this.props.valueAccessor(v);

      if (this.props.multi) {
        if (!(0, _utils.hasValue)(this.props.value)) {
          this.props.onChange([v]);
        } else if (this.props.value.reduce(function (a, c) {
          return a && !(0, _deepEqual["default"])(c, v);
        }, true)) {
          this.props.onChange([].concat(_toConsumableArray(this.props.value), [v]));
        }
      } else {
        this.props.onChange(v);
      }
    }
  }, {
    key: "removeItem",
    value: function removeItem(e, v) {
      e.stopPropagation();
      v = this.props.valueAccessor(v);

      if (this.props.multi) {
        this.props.onChange(this.props.value.filter(function (d) {
          return !(0, _deepEqual["default"])(d, v);
        }));
      } else {
        this.props.onChange(null);
      }
    }
  }, {
    key: "setSearch",
    value: function setSearch(search) {
      this.setState({
        search: search
      });
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this.props.options.length ? this.props.options : this.props.domain;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          accessor = _this$props.accessor,
          searchable = _this$props.searchable,
          customTheme = _this$props.customTheme,
          values = this.getValues(),
          search = this.state.search,
          _options = this.getOptions(),
          activeOptions = _options.filter(function (d) {
        return values.includes(d);
      }),
          listAccessor = this.props.listAccessor || accessor,
          options = !search ? _options : (0, _matchSorter.matchSorter)(_options, search, {
        keys: [listAccessor]
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(n) {
          return _this3.node = n;
        },
        className: "relative",
        onMouseLeave: function onMouseLeave(e) {
          return _this3.closeDropdown();
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "cursor-pointer"
      }, /*#__PURE__*/_react["default"].createElement(_parts.ValueContainer, {
        id: this.props.id,
        ref: function ref(n) {
          return _this3.vcNode = n;
        },
        onBlur: function onBlur(e) {
          return _this3.setState({
            hasFocus: false
          });
        },
        onFocus: function onFocus(e) {
          return _this3.setState({
            hasFocus: true
          });
        },
        hasFocus: this.state.opened || this.state.hasFocus,
        disabled: disabled,
        tabIndex: disabled ? -1 : 0,
        onClick: this.openDropdown,
        customTheme: customTheme
      }, values.length ? values.map(function (v, i, a) {
        return /*#__PURE__*/_react["default"].createElement(_parts.ValueItem, {
          key: i,
          disabled: disabled,
          customTheme: customTheme,
          remove: _this3.props.removable ? function (e) {
            return _this3.removeItem(e, v);
          } : null
        }, accessor(v, a));
      }) : /*#__PURE__*/_react["default"].createElement(_parts.ValueItem, {
        key: "placeholder",
        isPlaceholder: true
      }, this.props.placeholder))), disabled || !this.state.opened ? null : /*#__PURE__*/_react["default"].createElement(Dropdown, {
        opened: this.state.opened,
        direction: this.state.direction,
        searchable: searchable,
        ref: function ref(n) {
          return _this3.dropdown = n;
        },
        customTheme: customTheme
      }, !searchable ? null : /*#__PURE__*/_react["default"].createElement("div", {
        className: "p-2 pt-1 w-full"
      }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
        type: "text",
        autoFocus: true,
        placeholder: "search...",
        className: "w-full",
        value: this.state.search,
        onChange: function onChange(v) {
          return _this3.setSearch(v);
        }
      })), !options.length ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "p-1 text-center"
      }, "No Selections") : /*#__PURE__*/_react["default"].createElement("div", {
        className: "scrollbar overflow-y-auto",
        style: {
          maxHeight: "15rem"
        }
      }, options.map(function (d, i) {
        return /*#__PURE__*/_react["default"].createElement(DropdownItem, {
          key: "".concat(accessor(d), "-").concat(i),
          customTheme: customTheme,
          onClick: activeOptions.includes(d) ? function (e) {
            return e.stopPropagation();
          } : function (e) {
            return _this3.addItem(e, d);
          },
          isActive: activeOptions.includes(d)
        }, (0, _lodash["default"])(d, "OptionComponent") ? /*#__PURE__*/_react["default"].createElement(d.OptionComponent, {
          option: d
        }) : listAccessor(d));
      }))));
    }
  }]);

  return Select;
}(_react["default"].Component);

_defineProperty(Select, "defaultProps", {
  multi: false,
  searchable: false,
  domain: [],
  options: [],
  value: null,
  placeholder: "Select a value...",
  accessor: Identity,
  displayAccessor: null,
  listAccessor: null,
  id: "avl-select",
  autoFocus: false,
  disabled: false,
  removable: true,
  customTheme: {},
  valueAccessor: Identity
});

var _default = Select;
exports["default"] = _default;